import WidgetSearchRequest from '../api/WidgetSearchRequest.js';
export default (rfkId) => {
    const request = new WidgetSearchRequest(rfkId);
    request.setAppearance({});
    request.setAppearanceTemplates({});
    request.setAppearanceVariables({});
    return request;
};
